export default __webpack_public_path__ + "static/media/location-icon.b3732116.svg";